(function() {
  var Controller,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Controller = App.loadClass('core::Angular/Controller');

  exports.SidebarController = (function(superClass) {
    extend(SidebarController, superClass);

    function SidebarController(scope, transitions, state, FilterService, changes, window) {
      this.scope = scope;
      this.transitions = transitions;
      this.state = state;
      this.changes = changes;
      this.window = window;
      this.defineFilterLayout = bind(this.defineFilterLayout, this);
      this.beforeApply = bind(this.beforeApply, this);
      this.search = bind(this.search, this);
      this.setListeners = bind(this.setListeners, this);
      SidebarController.__super__.constructor.call(this, this.scope, this.transitions);
      this.scope.service = FilterService;
      this.scope.service.filter_url = 'backend/portal/key-fields-define/filters';
      this.scope.service.beforeApply = this.beforeApply;
      this.scope.service.setDefinitions(this.defineFilterLayout());
      this.geocoder = App.load('core::Geocoder');
      this.scope.search = this.search;
      this.setListeners();
      if (this.state.current.name === 'portal.keyfields_define') {
        this.state.go('.report', this.state.params, {
          location: false
        });
      }
    }


    /*
    Broadcast listeners
     */

    SidebarController.prototype.setListeners = function() {
      return this.scope.$on('KeyFieldDefine:displayMessage', (function(_this) {
        return function(dt, jsn_status) {
          if ((jsn_status.msg != null) && (jsn_status.type != null)) {
            return _this.scope.setAlert(jsn_status);
          }
        };
      })(this));
    };

    SidebarController.prototype.search = function(address) {
      return this.geocoder.geocode(address);
    };

    SidebarController.prototype.beforeApply = function() {
      if (this.changes.changesMade()) {
        return this.window.confirm('You have unsaved changes.\n\nAre you sure you want to leave this page?');
      }
      return true;
    };

    SidebarController.prototype.defineFilterLayout = function() {
      return [
        {
          name: 'Region Filters',
          filters: [
            {
              name: 'years',
              display_name: 'Year',
              control_type: 'single_dropdown',
              deletable: false,
              selected_values: [
                {
                  key: moment().year(),
                  value: moment().year()
                }
              ]
            }, {
              name: 'states',
              display_name: 'State'
            }, {
              name: 'zones',
              display_name: 'Zone'
            }, {
              name: 'counties',
              display_name: 'County'
            }, {
              name: 'zips',
              display_name: 'ZIP Code'
            }
          ]
        }, {
          name: 'Operation Filters',
          filters: [
            {
              name: 'companies',
              display_name: 'Company'
            }, {
              name: 'owners',
              display_name: 'User'
            }, {
              name: 'farms',
              display_name: 'Farm'
            }, {
              name: 'fields',
              display_name: 'Field'
            }
          ]
        }, {
          name: 'Key Fields',
          filters: [
            {
              name: 'seed_rep',
              display_name: 'Seed Rep'
            }, {
              name: 'date_planted',
              display_name: 'Date Planted',
              control_type: 'date_range',
              years_filter: 'years',
              options: {
                drops: 'up'
              },
              format: 'MM/DD'
            }, {
              name: 'maturity',
              display_name: 'Mat %',
              control_type: 'range'
            }, {
              name: 'seed_company',
              display_name: 'Seed Company',
              control_type: 'single_dropdown'
            }, {
              name: 'brands',
              display_name: 'Brand'
            }, {
              name: 'status',
              display_name: 'Status',
              control_type: 'single_dropdown'
            }
          ]
        }
      ];
    };

    return SidebarController;

  })(Controller);

}).call(this);
